import * as yup from "yup";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";

import Datepicker from "../../../components/common/Datepicker";
import moment from "moment";

const schema = yup.object({
  year: yup.string(),
});

const CorSettings = ({ year, setYear, setShow }) => {
  const [selectedYear, setSelectedYear] = useState(null);

  const [currentYear] = useState(
    Date.parse(moment(new Date(), "YYYY").toISOString())
  );

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const next_year = moment().add(1, "y");

  const disableFutureDates = (current) => {
    return current.isBefore(next_year);
  };

  const onSubmit = (data) => {
    const formatted_date = data.year.slice(data.year.length - 4);
    setYear(formatted_date);
    setShow(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2 gap-6">
        <div className="col-span-2">
          <Datepicker
            id="year-datepicker"
            name="year"
            title="Year"
            dateFormat="YYYY"
            setValue={setValue}
            clearErrors={clearErrors}
            register={register("year")}
            timeFormat={false}
            onDateChange={(date) => setSelectedYear(date)}
            value={selectedYear}
            initialValue={currentYear}
            errors={errors}
            isValidDate={disableFutureDates}
            isOpen={false}
            readOnly
          />
        </div>
      </div>
      <div className="grid grid-cols-2 pt-2">
        <div className="col-span-2">
          <button type="submit" className="button button-primary ">
            Apply Settings
          </button>
        </div>
      </div>
    </form>
  );
};

export default CorSettings;
